import React, { useState } from 'react';
import { Bell, Menu, User } from 'lucide-react';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { MOCK_NOTIFICATIONS } from '../../lib/mockData';
import { cn } from '../../lib/utils';
export function Header({
  onMenuClick
}: {
  onMenuClick: () => void;
}) {
  const [showNotifications, setShowNotifications] = useState(false);
  const unreadCount = MOCK_NOTIFICATIONS.filter(n => !n.read).length;
  return <header className="h-16 border-b border-slate-200 bg-white flex items-center justify-between px-4 lg:px-8 sticky top-0 z-30" data-id="element-30">
      <div className="flex items-center gap-4" data-id="element-31">
        <Button variant="ghost" size="icon" className="lg:hidden" onClick={onMenuClick} data-id="element-32">
          <Menu className="h-6 w-6" data-id="element-33" />
        </Button>
        <h1 className="text-lg font-semibold text-slate-800 hidden md:block" data-id="element-34">
          Welcome back, Mobility Plus
        </h1>
      </div>

      <div className="flex items-center gap-4" data-id="element-35">
        {/* Notification Bell */}
        <div className="relative" data-id="element-36">
          <Button variant="ghost" size="icon" className="relative" onClick={() => setShowNotifications(!showNotifications)} data-id="element-37">
            <Bell className="h-5 w-5 text-slate-600" data-id="element-38" />
            {unreadCount > 0 && <span className="absolute top-2 right-2 h-2.5 w-2.5 rounded-full bg-red-500 border-2 border-white" data-id="element-39" />}
          </Button>

          {/* Notification Dropdown */}
          {showNotifications && <div className="absolute right-0 mt-2 w-80 bg-white rounded-lg shadow-xl border border-slate-200 overflow-hidden z-50" data-id="element-40">
              <div className="p-3 border-b border-slate-100 flex justify-between items-center bg-slate-50" data-id="element-41">
                <h3 className="font-semibold text-sm" data-id="element-42">Notifications</h3>
                {unreadCount > 0 && <Badge variant="secondary" className="text-xs" data-id="element-43">
                    {unreadCount} new
                  </Badge>}
              </div>
              <div className="max-h-96 overflow-y-auto" data-id="element-44">
                {MOCK_NOTIFICATIONS.length === 0 ? <div className="p-4 text-center text-sm text-slate-500" data-id="element-45">
                    No notifications
                  </div> : MOCK_NOTIFICATIONS.map(notif => <div key={notif.id} className={cn('p-4 border-b border-slate-100 hover:bg-slate-50 transition-colors', !notif.read && 'bg-blue-50/50')} data-id="element-46">
                      <div className="flex gap-3" data-id="element-47">
                        <div className={cn('mt-1 h-2 w-2 rounded-full flex-shrink-0', notif.type === 'success' ? 'bg-green-500' : notif.type === 'error' ? 'bg-red-500' : 'bg-blue-500')} data-id="element-48" />
                        <div data-id="element-49">
                          <p className="text-sm font-medium text-slate-900" data-id="element-50">
                            {notif.title}
                          </p>
                          <p className="text-xs text-slate-500 mt-1" data-id="element-51">
                            {notif.message}
                          </p>
                          <p className="text-[10px] text-slate-400 mt-2" data-id="element-52">
                            {new Date(notif.timestamp).toLocaleDateString()} •{' '}
                            {new Date(notif.timestamp).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                          </p>
                        </div>
                      </div>
                    </div>)}
              </div>
              <div className="p-2 text-center border-t border-slate-100 bg-slate-50" data-id="element-53">
                <Button variant="ghost" size="sm" className="text-xs w-full" data-id="element-54">
                  Mark all as read
                </Button>
              </div>
            </div>}
        </div>

        {/* User Profile */}
        <div className="flex items-center gap-3 pl-4 border-l border-slate-200" data-id="element-55">
          <div className="text-right hidden md:block" data-id="element-56">
            <p className="text-sm font-medium text-slate-900" data-id="element-57">John Doe</p>
            <p className="text-xs text-slate-500" data-id="element-58">Mobility Plus Inc.</p>
          </div>
          <div className="h-9 w-9 rounded-full bg-slate-100 flex items-center justify-center border border-slate-200" data-id="element-59">
            <User className="h-5 w-5 text-slate-600" data-id="element-60" />
          </div>
        </div>
      </div>
    </header>;
}